import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    },
    componentForm2: function componentForm2() {
      return import('./sms');
    }
  },
  // pick_up_login:1(pick_code_pick)/2(login_pick)/3(all),register_method:mobile/email,screen_again_sms:no_display/display/fail_display,pick_code_english:1(number)/2(number with english),screen_upd_mobile:True/False
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), h("component-form-2", {
      "ref": "sms"
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'MARKET_SERVICE_CONFIG_ALL',
        delete: 'MARKET_SERVICE_CONFIG_DELETE',
        sync: 'MARKET_SERVICE_CONFIG_SYNC'
      },
      permission: {
        query: '',
        add: '',
        edit: '',
        detail: '',
        remove: '',
        sms_test: 'sms:test'
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var h = this.$createElement;
      return [{
        prop: 'id',
        label: this.$t('id'),
        minWidth: '80px'
      }, {
        prop: 'market_id',
        label: this.$t('market_mobile'),
        minWidth: '100px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("d2-dict", {
            "attrs": {
              "name": "table_market_id",
              "value": row.market_id,
              "custom": true
            }
          });
        }
      }, {
        prop: 'service_type',
        label: this.$t('service_type'),
        minWidth: '120px'
      }, {
        prop: 'service_config',
        label: this.$t('service_config'),
        minWidth: '120px',
        formatter: function formatter(row) {
          return JSON.stringify(row.service_config);
        }
      }, {
        prop: 'status',
        label: this.$t('status'),
        minWidth: '120px',
        render: function render(_ref2) {
          var row = _ref2.row;
          return h("d2-dict", {
            "attrs": {
              "name": "service_config_status",
              "value": row.status
            }
          });
        }
      }, {
        prop: 'ctime',
        label: this.$t('ctime'),
        minWidth: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.ctime, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'uptime',
        label: this.$t('uptime'),
        minWidth: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.uptime, 'YYYY/M/D HH:mm:ss');
        }
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this2 = this;

      return function (_ref3) {
        var row = _ref3.row;
        return [].concat(_toConsumableArray(_this2.p('edit', [{
          icon: 'el-icon-edit-outline',
          action: function action() {
            return _this2.edit(row.id);
          }
        }], [])), _toConsumableArray(row.service_type == 'system' ? _this2.p('detail', [{
          icon: 'el-icon-collection',
          label: _this2.$t('sync config'),
          type: 'danger',
          confirm: _this2.$t('confirm_sync_config'),
          action: function action() {
            return _this2.sync({
              'id': row.id
            });
          }
        }], []) : []), _toConsumableArray(_this2.p('remove', [{
          icon: 'el-icon-delete',
          type: 'danger',
          confirm: _this2.$t('confirm_delete_info'),
          action: function action() {
            return _this2.delete(row.id);
          }
        }], [])), _toConsumableArray(row.service_type == 'sms' ? _this2.p('sms_test', [{
          icon: 'el-icon-s-check',
          label: 'test sms',
          action: function action() {
            return _this2.edit(row.id, 'sms');
          }
        }], []) : []));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this3 = this;

      var h = this.$createElement;
      return [{
        prop: 'market_id',
        label: this.$t('market_id'),
        default: this.market_id ? this.market_id : utils.cookies.get('market_id'),
        show: false,
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "model": {
              value: _this3.search.form.model.market_id,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "market_id", $$v);
              }
            }
          });
        } // render: () => <d2-dict-select name="search_market_id" vModel={ this.search.form.model.market_id } style="width:140px;" custom clearable/>

      }, {
        prop: 'market_mobile',
        label: this.$t('market_mobile'),
        default: this.market_mobile ? this.market_mobile : utils.cookies.get('phone'),
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "attrs": {
              "disabled": true
            },
            "model": {
              value: _this3.search.form.model.market_mobile,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "market_mobile", $$v);
              }
            }
          });
        } // render: () => <d2-dict-select name="search_market_id" vModel={ this.search.form.model.market_id } style="width:100px;" custom clearable/>

      }, // {
      //   prop: 'status',
      //   label: 'status',
      //   default: '',
      //   render: () => <d2-dict-select name="service_config_status" vModel={ this.search.form.model.status } style="width:170px;" custom clearable/>
      // },
      {
        prop: 'start_time',
        label: this.$t('start_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "start_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.start_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: this.$t('end_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "end_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.end_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }];
    },
    // [本页面特有] 父级字典项目的 id 强制转为数字
    market_mobile: function market_mobile() {
      return this.$route.query.market_mobile;
    },
    market_id: function market_id() {
      return this.$route.query.market_id;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['closeBy'])), {}, {
    loadDict: function loadDict() {
      this.loadDictOne({
        name: 'search_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
      this.loadDictOne({
        name: 'table_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
    }
  })
};